import { initials } from "../lib/format";

export function Avatar({
  name,
  url,
  size = "medium",
  status,
}: {
  name: string;
  url?: string;
  size?: "small" | "medium" | "large";
  status?: "online" | "away";
}) {
  return (
    <span className={`avatar avatar--${size}`} aria-label={name} title={name}>
      {url ? <img src={url} alt="" /> : <span aria-hidden="true">{initials(name)}</span>}
      {status && <i className={`avatar__status avatar__status--${status}`} aria-hidden="true" />}
    </span>
  );
}

